module.exports = __webpack_public_path__ + "img/context-1.423b1409.gif";